<template>
  <div class="container">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      success-text="刷新成功"
    >
      <div class="applyContainer">
        <div class="header">
          <div class="profile-box">
            <img :src="user.avatar" alt />
          </div>
          <div class="nickFile">
            <p class="text1">Hi,{{ user.nickName }}</p>
          </div>
        </div>
        <div class="center-box">
          <div class="ranking-box">
            <p class="text1">老师您好:</p>
            <p class="text">您的入会申请已收到，入会审核需要您提供如下资料：</p>
            <p class="text">1、执业医师证书扫描件或照片（执业范围页）;</p>
            <p class="text">2、眼科医生的资格证书扫描件或照片;</p>
            <p class="text">3、附件为北京眼科学会会员登记表;</p>
            <p class="text">
              请您填好登记表（军队医院人员需要按照《军队社会团体管理工作规定》，
              履行相应的审批手续，并在登记表上加盖公章），连同其他资料线上提交，
              我们收到资料后进行审核，并根据《北京眼科学会章程》规定报学会理事会审批。
              理事会审批通过后，我们将以短信方式通知您，为您办理入会手续，
              请您缴纳会员费，学会秘书处将为您邮寄学会会员证书。
            </p>
            <p class="text">
              <span style="color: red"
                >* 请您务必留意短信通知，以便后续入会操作。</span
              >
            </p>
            <p class="text">
              <span style="color: red"
                >* 按照北京市民政局的有关规定，本会会员分布和活动地域为北京市，
                对于外地申请人，我们很遗憾的告知您的申请不能被受理，
                在此感谢您对北京眼科学会的关注！</span
              >
            </p>

            <p class="text" style="margin-top: 20px">
              入会后您可以享有学会章程规定的以下会员权利：
            </p>
            <p class="text">（一） 本会的选举权、被选举权和表决权；</p>
            <p class="text">（二） 对本会工作的知情权、建议权和监督权；</p>
            <p class="text">（三）参加本会活动并获得服务的优先权；</p>
            <p class="text">（四）入会自愿、退会自由；</p>
            <p class="text">同时，您需要按规定履行下列会员义务:</p>
            <p class="text">（一）遵守本会的章程和各项制度；</p>
            <p class="text">（二）执行本会的决议；</p>
            <p class="text">（三）维护本会的合法权益；</p>
            <p class="text">（四） 按规定交纳会费；</p>
            <p class="text">（五） 向本会反映情况，提供有关资料；</p>
            <p class="text">（六） 完成本团体交办的工作；</p>

            <p class="text" style="margin-top: 20px">
              北京眼科学会期待您的加入！
            </p>
          </div>
        </div>
        <div class="form">
          <div class="rolItems items1">
            <mt-field
              label="手机号："
              class="inputTxt"
              v-reset-page
              type="text"
              v-model="dataInfo.mobile"
              placeholder="请输入手机号"
              :disabled="[0, 1, 3, 4, 5].indexOf(dataInfo.status) != -1"
            ></mt-field>
          </div>
          <div class="rolItem">
            <span>1、下载会员信息附件:</span>&nbsp;&nbsp;&nbsp;
            <span @click="upload" class="down_a">点击下载附件</span>
          </div>
          <div class="rolItem">
            <span>2、执业医师证书:</span>
            <div>
              <SignUpload
                v-on:avatarInput="formUrl"
                class="upload"
                title="上传执业医师证书图片"
                name="physiciansImg"
                :imgList="dataInfo.physiciansImg || ''"
                :disabled="[0, 1, 3, 4, 5].indexOf(dataInfo.status) != -1"
              />
            </div>
          </div>
          <div class="rolItem">
            <span>3、眼科医生资格证书:</span>
            <div>
              <SignUpload
                v-on:avatarInput="formUrl"
                class="upload"
                title="上传眼科医生资格证书图片"
                name="ophthalmologistImg"
                :imgList="dataInfo.ophthalmologistImg || ''"
                :disabled="[0, 1, 3, 4, 5].indexOf(dataInfo.status) != -1"
              />
            </div>
          </div>

          <div class="rolItem">
            <span>4、会员信息附件:</span>
            <div>
              <SignUpload
                v-on:avatarInput="formUrl"
                class="upload"
                title="上传会员信息附件"
                name="memberAccessoryUrl"
                :imgList="dataInfo.memberAccessoryUrl || ''"
                :disabled="[0, 1, 3, 4, 5].indexOf(dataInfo.status) != -1"
              />
            </div>
          </div>
        </div>
        <div class="getBtn">
          <mt-button type="primary" class="btn" v-if="dataInfo.status == 0">
            待审核</mt-button
          >
          <mt-button
            type="primary"
            class="btn"
            @click="submit"
            v-else-if="
              dataInfo.status == '' ||
              dataInfo.status == null ||
              dataInfo.status == 2
            "
          >
            {{ dataInfo.status == 2 ? '重新提交' : '提交' }}</mt-button
          >
          <mt-button type="primary" class="btn" v-else> 审核已通过</mt-button>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import SignUpload from '../../components/SignUpload.vue'
import {
  videoShare,
  shareTitle,
  shareUrl,
  shareImg,
  shareDesc,
} from '@/common/wxshare'
export default {
  components: { SignUpload },
  name: 'Apply',
  data() {
    return {
      dataInfo: {
        memberAccessoryUrl: '',
        ophthalmologistImg: '',
        physiciansImg: '',
        mobile: '',
      },
      user: {},
      isLoading: false,
    }
  },
  created() {},
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.getDetail()
  },
  methods: {
    upload() {
      var a = document.createElement('a')
      a.href =
        'https://m-live-bucket.oss-cn-beijing.aliyuncs.com/%E5%AD%A6%E4%BC%9A%E4%BC%9A%E5%91%98%E7%99%BB%E8%AE%B0%E8%A1%A8/%E5%8C%97%E4%BA%AC%E7%9C%BC%E7%A7%91%E5%AD%A6%E4%BC%9A%E4%BC%9A%E5%91%98%E7%99%BB%E8%AE%B0%E8%A1%A8.docx'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    onRefresh() {
      this.getDetail()
    },
    //   审核详情查询
    getDetail() {
      this.$http({
        url: `/xhMember/getInfoByOpenId/${sessionStorage.getItem('openId')}`,
        method: 'get',
      }).then(({ data }) => {
        this.isLoading = false
        if (data.data && data.code === 0) {
          this.dataInfo = data.data
          if (data.data.status == 2) {
            this.$toast('初审被驳回，请重新提交')
          }
          if (data.data.status !== 0 && data.data.status !== 2) {
            this.$toast({
              message: '初审已通过，请您留意短信审核通知！',
              duration: 3000,
            })
          }
        }
      })
    },
    // 获取上传地址
    formUrl(url, name) {
      this.dataInfo[name] = url
    },
    // 提交认证信息
    submit() {
      if (!this.dataInfo.mobile) {
        this.$toast('手机号不能为空')
        return this
      } else {
        var checkMobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!checkMobile.test(this.dataInfo.mobile.trim())) {
          this.$toast('手机号格式错误！')
          return this
        }
      }
      if (!this.dataInfo.physiciansImg) {
        this.$toast('执业医师证书不能为空')
        return this
      }
      if (!this.dataInfo.ophthalmologistImg) {
        this.$toast('眼科医生资格证书不能为空')
        return this
      }
      if (!this.dataInfo.memberAccessoryUrl) {
        this.$toast('会员信息附件不能为空')
        return this
      }
      this.$http({
        url: '/xhMember/save',
        method: 'post',
        data: { ...this.dataInfo, openId: sessionStorage.getItem('openId') },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$toast({
            message: '申请已提交,请您留意短信审核通知！',
            duration: 3000,
          })
          this.getDetail()
        } else {
          this.$toast(data.msg)
        }
      })
    },
    wxShare() {
      // 分享
      const shareTitle = '入会申请'
      const shareUrl = location.href
      const shareImg =
        'https://m-live-bucket.oss-cn-beijing.aliyuncs.com/2020/08/06/cc5bca97-89a8-46eb-8fd7-8f6c7c0f7ed0_f97d247b94aa981b37e164ff2f57b34.png'
      const shareDesc = '入会申请'
      videoShare(this, shareTitle, shareUrl, shareImg, shareDesc)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding-left: 0px;
  padding-right: 0px;
  width: 100%;
  .van-pull-refresh {
    width: 100% !important;
    height: 100vh !important;
    overflow: scroll !important;
    height: 101%;
  }
  .header {
    height: 18rem;
    background: url(../../assets/img/timg.jpg) no-repeat;
    position: relative;
    box-sizing: border-box;
    padding: 10px;
    color: #566079;
    .profile-box {
      width: 6rem;
      height: 6rem;
      border: 2px solid #ffffff;
      border-radius: 50%;
      float: left;
      margin: 2rem 0.4rem 0 1rem;
      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 50%;
      }
    }
    .nickFile {
      position: absolute;
      left: 85px;
      margin: 2rem 0.4rem 0 1rem;
      .text1 {
        font-size: 22px;
        line-height: 70px;
      }
      .text2 {
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }
  .center-box {
    // height: 37rem;
    background: #e8e8e8;
    position: relative;
    // padding: 0 10px;
    box-sizing: border-box;
    margin: -4rem auto 10px auto;
    z-index: 10;
    height: auto;
    overflow: hidden;
    width: 96%;
    padding-bottom: 5px;
    .ranking-box {
      padding: 10px;
      background: #fff;
      right: 10px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(255, 255, 255, 0.7);

      overflow: scroll;
      font-size: 14px;
    }
    .text {
      text-indent: 2em;
      line-height: 36px;
    }
    .text1 {
      line-height: 36px;
    }
  }
  .form {
    .rolItem {
      padding: 1rem;
      height: auto;
      overflow: hidden;
      font-size: 14px;
    }
  }
  .getBtn {
    box-sizing: border-box;
    margin-top: 20px;
    height: 55px;
    padding: 0 1rem;
    padding-bottom: 1rem;
    width: 100%;
    background-color: #fff;
    text-align: center;
  }
  .btn {
    width: 90%;
    height: 100%;
    font-size: $font-title;
    border-radius: 10px;
    line-height: 36px;
    padding: 0 !important;
  }
  .btn:hover {
    color: #fff;
    text-decoration: none;
    border: none;
  }
  .btn:focus,
  .btn.focus {
    outline: 0;
    box-shadow: none;
  }
  .down_a {
    color: #f5a323 !important;
  }
  .items1 {
    line-height: 36px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    .mint-cell-title {
      min-width: 105px !important;
    }
  }
  .mint-cell-text,
  .mint-cell-value {
    font-size: 14px;
  }
  .mint-field .mint-cell-title {
    min-width: 105px !important;
    width: auto !important;
  }
}
</style>
